<template>
  <div>
    <section-definition title="Atividade Extra de Quadro Horário" event-update="pesquisar"></section-definition>
    <v-toolbar dark color="primary">
      <v-toolbar-title>Gerenciar Atividade Extra de Quadro Horário</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <modal-cadastro-qh-atv-extra :plano="plano" @qhAtvExtraCadastrada="cadastroEfetuado = $event"/>
    </v-toolbar>
    <modal-participantes-qh-atv-extra/>
    <v-container fluid>
      <v-form ref="form" class="hidden-sm-and-down">
        <v-layout align-center row fill-height justify-space-between>
          <v-flex xs12 sm6 md2>
            <v-select v-model="filtro.ano" :items="anos" label="Ano" clearable
              @change="aoSelecionarAno"></v-select>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-select v-model="filtro.numero" :items="numeros" label="Número" clearable
              :disabled="!filtro.ano" @change="aoSelecionarNumero"></v-select>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-text-field color="primary" label="Data Início" disabled v-model="plano.dataInicio"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-text-field color="primary" label="Data Fim" disabled v-model="plano.dataFim"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md4>
            <v-text-field color="primary" label="Descrição" disabled v-model="plano.descricao"></v-text-field>
          </v-flex>
        </v-layout>
      </v-form>
      <div class="qh-atv-extras-scroll">
        <v-data-table :loading="loading" :headers="headers" :items="atividades" class="elevation-1" hide-actions>
          <template slot="items" slot-scope="props">
            <td>{{ props.item.data }}</td>
            <td>{{ props.item.diaSemana }}</td>
            <td>{{ props.item.descricao }}</td>
            <td class="text-xs-center">{{ props.item.qtdeHora }}</td>
            <td>
              <v-icon v-if="plano.ativo" title="Editar" medium class="mr-2" @click="editar(props.item)">
                edit
              </v-icon>
              <v-icon v-if="plano.ativo" title="Excluir" medium class="mr-2" @click="excluir(props.item)">
                delete
              </v-icon>
              <v-icon title="Participantes" medium class="mr-2" @click="verParticipantes(props.item)">
                group
              </v-icon>
            </td>
          </template>
          <template slot="no-data">
            Nenhuma atividade extra cadastrada para o plano!
          </template>
        </v-data-table>
      </div>
    </v-container>
  </div>
</template>
<script>
import qhAtvExtraService from "@/service/qh/QhAtvExtraService";
import qhPlanoService from "@/service/qh/QhPlanoService";
import QhPlanoResumo from "@/model/qh/QhPlanoResumo";
import EventBus from "@/utils/EventBus.js";
import ModalCadastroQhAtvExtra from "./ModalCadastroQhAtvExtra";
import ModalParticipantesQhAtvExtra from "./ModalParticipantesQhAtvExtra";
export default {
  components: {
    ModalCadastroQhAtvExtra,
    ModalParticipantesQhAtvExtra
  },
  data() {
    return {
      loading: false,
      cadastroEfetuado: false,
      atividades: [],
      anos: [],
      numeros: [],
      filtro: { ano: null, numero: null },
      plano: new QhPlanoResumo(),
      headers: [
        { text: "Data", align: "left", sortable: false, value: "data" },
        { text: "Dia Semana", align: "left", sortable: false, value: "diaSemana" },
        { text: "Descrição", align: "left", sortable: false, value: "descricao" },
        { text: "Qtde Horas", align: "center", sortable: false, value: "qtdeHora" },
        { text: "Ações", value: "name", sortable: false }
      ]
    };
  },
  watch: {
    cadastroEfetuado(event) {
      if (event) {
        setTimeout(() => {
          this.pesquisar();
          this.cadastroEfetuado = false;
        }, 500);
      }
    }
  },
  created() {
    this.carregarAnos();
  },
  methods: {
    async carregarAnos() {
      // RN001.1: anos com planos ativos da instituição.
      this.anos = (await qhPlanoService.listarAnos(true)) || [];
    },
    async aoSelecionarAno() {
      this.filtro.numero = null;
      this.plano = new QhPlanoResumo();
      this.atividades = [];
      if (this.filtro.ano) {
        this.numeros = await qhPlanoService.listarNumeros(this.filtro.ano);
      } else {
        this.numeros = [];
      }
    },
    async aoSelecionarNumero() {
      this.atividades = [];
      this.plano = new QhPlanoResumo();
      if (!this.filtro.numero) {
        return;
      }
      const paginacao = await qhPlanoService.listarTodos(
        { ano: this.filtro.ano, numero: this.filtro.numero }, 1, 1
      );
      if (paginacao && paginacao.dados && paginacao.dados.length > 0) {
        this.plano = new QhPlanoResumo(paginacao.dados[0]);
        this.pesquisar();
      }
    },
    async pesquisar() {
      if (!this.plano.id) {
        this.atividades = [];
        return;
      }
      this.loading = true;
      this.atividades = (await qhAtvExtraService.listarPorPlano(this.plano.id)) || [];
      this.loading = false;
    },
    editar(atv) {
      EventBus.$emit("editaQhAtvExtra", atv.id);
    },
    excluir(atv) {
      confirm("Deseja realmente excluir o registro de atividade?") &&
        qhAtvExtraService.excluir(atv).then(retorno => {
          if (retorno) {
            this.pesquisar();
          }
        });
    },
    verParticipantes(atv) {
      EventBus.$emit("verParticipantesQhAtvExtra", atv);
    }
  }
};
</script>
<style scoped>
.qh-atv-extras-scroll {
  max-height: calc(100vh - 320px);
  overflow-y: auto;
  overflow-x: auto;
}
</style>
